const firebaseConfig = {
  apiKey: 'AIzaSyCuI_7QcMKABGgz4sPsNv7FtO6xmaqhbGc',
  authDomain: 'shopbooks-team.firebaseapp.com',
  projectId: 'shopbooks-team',
  storageBucket: 'shopbooks-team.appspot.com',
  messagingSenderId: '519311928346',
  appId: '1:519311928346:web:727db45742c423a9a1f5a3',
};

export default firebaseConfig;
